import React from 'react'
import OperacionesCorreos from '../containers/asignacionCupos/OperacionesCorreos'

export const COLUMNS_CORREOS_EXPORTADOR = [
  {
    name: 'nombre',
    label: 'Nombre y Apellido',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'correoElectronico',
    label: 'Correo Electrónico',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'id',
    label: 'Acciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return <OperacionesCorreos id={value} />
      }
    }
  }
]

export const COLUMNS_CORREOS_EXPORTADOR_TO_PRINT = [
  {}
]
